import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Homepage from '../../pages/homepage/Homepage';
import Form from '../../pages/formpage/Formpage';
import About from '../../pages/About';
import NotFound from '../../pages/NotFound';
import DetailCard from '../../components/detailCard/DetailCard';
import { PATHS } from '../../utils/constants';
import './_main.scss';

function Main() {
  return (
    <Routes>
      <Route path={PATHS.homepage} element={<Homepage />} />
      <Route path={PATHS.videoIds} element={<DetailCard />} />
      <Route path={PATHS.about} element={<About />} />
      <Route path={PATHS.form} element={<Form />} />
      <Route path={PATHS.page404} element={<NotFound />} />
    </Routes>
  );
}

export default Main;
